import React from 'react';
import { OptionProps as RsOptionProps, components } from 'react-select';
import { FilterTagOption } from '@shared/components/filter/types';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';
import staticStyles from './styles.module.css';

export interface OptionProps<T = FilterTagOption> extends RsOptionProps<T> {
  icon?: MBIconV2Name;
  showCheckbox?: boolean;
  styles: React.CSSProperties;
}
/* custom Option component passed to react-select */
export function Option<T = FilterTagOption>({
  children,
  icon,
  styles = {},
  showCheckbox = true,
  ...props
}: OptionProps<T>) {
  return (
    <components.Option {...props} getStyles={() => ({})}>
      <div className={staticStyles.option} style={styles}>
        <div className={staticStyles.content}>
          {!!icon && (
            <div style={{ marginRight: grid(1) }}>
              <MBIconV2 name={icon} color={Colors.v2.purple} size={grid(3)} />
            </div>
          )}
          {children}
        </div>
        {showCheckbox && (
          <>
            {props.isSelected && (
              <MBIconV2 name="check-box" color={Colors.v2.green} size={grid(3.5)} />
            )}
            {!props.isSelected && (
              <MBIconV2 name="check-box-empty" color={Colors.v2.green} size={grid(3.5)} />
            )}
          </>
        )}
      </div>
    </components.Option>
  );
}
